
import { Accordion, AccordionDetails, AccordionSummary, Card, CardActionArea, CardContent, CardMedia, Grid, } from '@mui/material';
import Consolas from '../../../fonts/Consolas';
import { H3, H5, H6, PARAGRAPH } from '../../../helper/constants';
import { EduCardProps } from './helper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { Fragment } from "react"
import { camelToTitle, optionalString } from '../../../helper/functions';
import { EduCourse } from '../../../helper/types';
import { useUnwrapper } from '../../../helper/functions/hooks';
import Break from '../../Break';
import Tags from '../../Tags';


const EduCard = ({ degree, school, gradDate, image, link, courses, schoolLink, tools }: EduCardProps): JSX.Element => {
    const { e: entries } = useUnwrapper<EduCourse>(courses)
    return (
        <Grid item xs>
            <Card>
                <CardActionArea href={optionalString(schoolLink)} target="_blank">
                    <CardMedia
                        component="img"
                        image={image}
                        title={school} />
                </CardActionArea>

                    <CardActionArea href={optionalString(link)} target="_blank">
                        <CardContent title='See Degree'>
                            <Consolas as={H3}>{school}</Consolas>
                            <Consolas as={H6}>⭐ {degree}</Consolas>
                            <Consolas as={PARAGRAPH}>🎓 {gradDate}</Consolas>
                        </CardContent>
                    </CardActionArea>
                <Accordion
                    aria-controls="panel1a-content"
                    id="panel1a-header">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header">
                        <Consolas as={15}>Courses</Consolas>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Fragment>
                            {
                                entries.map(([key, values]: [string, string[]], i: number) =>
                                (
                                    <Fragment key={i}>
                                        <Consolas as={H5}>{camelToTitle(key)}</Consolas>
                                        <ul>
                                            {
                                                values.map((value: string, j: number) =>
                                                (
                                                    <li key={j}><Consolas as={PARAGRAPH}>{value}</Consolas></li>
                                                ))
                                            }
                                        </ul>
                                    </Fragment>
                                ))
                            }
                        </Fragment>
                        <Break />
                        <Tags collection={tools}/>


                    </AccordionDetails>

                </Accordion>
            </Card>
        </Grid >
    )
}


export default EduCard;
